import { NgModule } from '@angular/core';
import { NoPreloading, PreloadAllModules, RouteReuseStrategy, RouterModule, Routes, UrlSegment } from '@angular/router';
import { AppRouteReuseStrategy } from '@heda/core-util';
import { environment } from 'environments/environment';

const paths = {
  reception: [
    'reception',
    'schedules',
    'slots',
    'slot-types',
    'healthcare-services',
    'referrals',
    'disability-certificates',
    'appointments',
    'appointment-plans',
    'report',
    'documents',
    'diets',
    'food',
    'nutritions',
    'mealtimes',
    'encounters',
    'inpatients',
    'emergencies',
    'bed-days',
    'episodes',
  ],
  accounting: ['accounting', 'invoices', 'payments', 'items', 'item-groups', 'pricelists', 'wms', 'insurance-plans'],
  mdm: [
    'mdm',
    'parameters',
    'codesystems',
    'dashboard-configs',
    'dictionaries',
    'locations',
    'location-groups',
    'templates',
    'jobs',
    'practitioners',
    'organizations',
    'organization-groups',
    'drools',
    'tam-import',
    'tehik-import',
    'tenants',
    'sequences',
    'printouts',
    'observation-definitions',
    'observation-groups',
    'measurement-units',
    'questionnaires',
    'medications',
    'medication-groups',
    'medication-products',
    'med-devices',
    'med-device-groups',
    'diagnoses',
    'group-definitions',
    'study-devices',
    'snomed',
  ],
  // TODO Cannot lazyload integration because AfterLoginHandler requires IntegrationService.
  // integration: [
  //   'integration',
  //   'documents'
  // ]
};

// Need these exported functions for the AOT compiler.
export function multiMatch(paths: string[], url: UrlSegment[]) {
  return url.length > 0 && paths.includes(url[0].path) ? { consumed: [] } : null;
}

export function receptionMatch(url: UrlSegment[]) {
  return multiMatch(paths.reception, url);
}

export function accountingMatch(url: UrlSegment[]) {
  return multiMatch(paths.accounting, url);
}

export function mdmMatch(url: UrlSegment[]) {
  return multiMatch(paths.mdm, url);
}

const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard/personal/plan',
    pathMatch: 'full',
  },
  {
    matcher: receptionMatch,
    loadChildren: () => import('./reception/reception.module').then((m) => m.ReceptionModule),
  },
  {
    matcher: accountingMatch,
    loadChildren: () => import('./accounting/accounting.module').then((m) => m.AccountingModule),
  },
  {
    matcher: mdmMatch,
    loadChildren: () => import('./mdm/mdm.module').then((m) => m.MdmModule),
  },
  {
    path: 'umka',
    loadChildren: () => import('./umka/umka.module').then((m) => m.UmkaModule),
  },
  {
    path: 'sauron',
    loadChildren: () => import('./sauron/sauron-module').then((m) => m.SauronModule),
  },
  {
    path: 'treatment',
    loadChildren: () => import('./treatment/treatment-module').then((m) => m.TreatmentModule),
  },
  {
    path: 'proto',
    loadChildren: () => import('./proto/proto.module').then((m) => m.ProtoModule),
  },
  {
    path: 'mpi',
    loadChildren: () => import('./mpi/mpi.module').then((m) => m.MpiModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'devtools',
    loadChildren: () => import('./devtools/devtools.module').then((m) => m.DevtoolsModule),
  },
  {
    path: 'procman',
    loadChildren: () => import('./procman/procman-module').then((m) => m.ProcmanModule),
  },
  {
    path: 'management',
    loadChildren: () => import('./management/management.module').then((m) => m.ManagementModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: environment.production || environment.preloadModules ? PreloadAllModules : NoPreloading,
    }),
  ],
  exports: [RouterModule],
  providers: [{ provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy }],
})
export class AppRoutingModule {}
